












import Vue from "vue";
/* eslint-disable */
import {
  createComponent,
  ref,
  Ref,
  computed,
  watch
} from "@vue/composition-api";
/* eslint-enable */

interface BaseProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export default createComponent({
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    }
  },
  setup(props: Readonly<BaseProgressBarProps>) {
    const progressBar: Ref<any> = ref();

    const progressPercentage = computed(
      () => (props.currentStep / props.totalSteps) * 100
    );

    const updateStyle = (curr: number) => {
      const percentageText = curr.toFixed(0);
      const bgImage =
        "linear-gradient(to right, #00a881 " +
        percentageText +
        "%, rgba(202, 217, 230, 0.7) " +
        percentageText +
        "%)";

      Vue.nextTick(() => {
        if (progressBar.value) {
          progressBar.value.style.backgroundImage = bgImage;
        }
      });
    };

    watch(progressPercentage, updateStyle);
    updateStyle(progressPercentage.value);

    return {
      progressBar
    };
  }
});
